import {TableTop} from "./TableTop";
import moment from "moment";
import {getDailyTableName, getNameByCode, getRaceLink, getTermsAndConditions} from '../helpers/functions';
import {useRef, useState} from 'react';
import {useAPIData} from "../context/hooks/useAPIData";
import TrackingLink from "./TrackingLink";
import {TablePrizes} from "./TablePrizes";


export const Race = (props) => {
    const {type} = props
    const myRef = useRef();
    const data = useAPIData()
    const {title, faqInfo} = getNameByCode(props.races[0].code)
    const phoneView = window.innerWidth < 768
    const [selectedTab, setSelectedTab] = useState(1)
    const differentMonth = moment(props.races[0].start).format('MM') !== moment(props.races[0].end).format('MM')
    return (<section ref={myRef} key={props.keyNr}>
        <div className="section-header">
            <div>
                <h1>{title}</h1>
                <p className="updatedAt">
                    <span>{moment(props.races[0].start).format(differentMonth ? 'D MMMM' : 'D') +
                    ' - ' + moment(props.races[0].end).locale('ro').format('DD MMMM')}
                    </span>
                    {moment(props.races[0].end).isAfter(moment()) && props.races[0].lastFetchTime ?
                        <span>Actualizată la {moment(props.races[0].lastFetchTime).format('HH:mm:ss')}</span>
                        : ''}
                </p>
            </div>
            <button onClick={() => data.openModal(title, faqInfo)} className="info-button">?</button>
        </div>
        <div className={"section-wrapper " + (type === 'double' ? '' : ' single-table-race single')}>
            {type === 'double' && <div className={'tabs ' + (phoneView ? 'long-tab ' : '') + (selectedTab === 2 ? 'toRight' : '')}>
                <p onClick={() => setSelectedTab(1)}
                   className={'tab ' + (selectedTab === 1 ? 'active-tab' : '')}>Clasament</p>
                <p onClick={() => setSelectedTab(2)} className={'tab ' + (selectedTab === 2 ? 'active-tab' : '')}>{getDailyTableName(props.races[1].code)}</p>
            </div>}
            <TableTop raceRef={myRef} inactive={props.inactive} visible={selectedTab === 1} data={props.races[0]}/>
            {type === 'double' ? <TablePrizes raceRef={myRef} inactive={props.inactive} visible={selectedTab === 2} data={props.races[1]}/> : <></>}
        </div>
        <div className="legal-buttons">
            {!data.princessAgent && <button><TrackingLink href={getRaceLink(props.races[0].code)}>Joacă acum</TrackingLink></button>}
            <a onClick={() => data.openModal('PRINCESS RACES', getTermsAndConditions(props.races[0].code))}>Termeni și
                condiții</a>
        </div>
    </section>)
}